import { storage } from '@vmos2/core';

export const getKioskId = () => storage.getItem('kioskID');
